/*--------------- Calmcarry Bundle Offer JS ------------------*/

$(document).on('click','.calm-custom-offer-block-item', function(){
  
  $('.calm-custom-offer-block-item').removeClass('active');
  $(this).addClass('active');
  $('.calm-custom-offer-item-options').hide();
  $(this).find('.calm-custom-offer-item-options').show();
  var dataNumber = $(this).attr('data-number');
  
  $('.calm-custom-offer-btn').attr('data-number', dataNumber);
  
});



$(document).on('click','.calm-custom-offer-btn', function(){
  var VarNum =  $(this).attr('data-number');
   
  var totalVariant = '';
  if (VarNum == 1){
     var VarColor1 =  $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-1 option:selected').val();
     var totalVariant = [VarColor1];

  }
  else if (VarNum == 3){
    var VarColor1 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-1 option:selected').val();
    var VarColor2 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-2 option:selected').val();
    var VarColor3 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-3 option:selected').val();
    var totalVariant = [VarColor1, VarColor2, VarColor3];
   
  }
  else if (VarNum == 5){
    var VarColor1 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-1 option:selected').val();
    var VarColor2 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-2 option:selected').val();
    var VarColor3 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-3 option:selected').val();
    var VarColor4 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-4 option:selected').val();
    var VarColor5 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-5 option:selected').val();
    var totalVariant = [VarColor1, VarColor2, VarColor3, VarColor4, VarColor5];
    
  }
  else if (VarNum == 7){
    var VarColor1 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-1 option:selected').val();
    var VarColor2 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-2 option:selected').val();
    var VarColor3 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-3 option:selected').val();
    var VarColor4 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-4 option:selected').val();
    var VarColor5 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-5 option:selected').val();
    var VarColor6 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-6 option:selected').val();
    var VarColor7 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-7 option:selected').val();
    var totalVariant = [VarColor1, VarColor2, VarColor3, VarColor4, VarColor5, VarColor6, VarColor7];
   
  }

    var data = {
       "id": totalVariant,
       "quantity":1,
  }
  setTimeout(function () {
      $.ajax({
        type: 'POST', 
        url: '/cart/add.js',
        dataType: 'json', 
        data: data,
        success: function() { 
        
          window.monster_refresh(open, data)

        },
        error: function(error) {alert(error.responseJSON.message);}
       });
  }, 1000);

});


$(document).on('click','.calm-custom-buy-btn', function(){
  clearCart();
  var VarNum =  $(this).attr('data-number');
   
  var totalVariant = '';
  if (VarNum == 1){
     var VarColor1 =  $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-1 option:selected').val();
     var totalVariant = [VarColor1];

  }
  else if (VarNum == 3){
    var VarColor1 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-1 option:selected').val();
    var VarColor2 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-2 option:selected').val();
    var VarColor3 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-3 option:selected').val();
    var totalVariant = [VarColor1, VarColor2, VarColor3];
   
  }
  else if (VarNum == 5){
    var VarColor1 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-1 option:selected').val();
    var VarColor2 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-2 option:selected').val();
    var VarColor3 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-3 option:selected').val();
    var VarColor4 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-4 option:selected').val();
    var VarColor5 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-5 option:selected').val();
    var totalVariant = [VarColor1, VarColor2, VarColor3, VarColor4, VarColor5];
    
  }
  else if (VarNum == 7){
    var VarColor1 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-1 option:selected').val();
    var VarColor2 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-2 option:selected').val();
    var VarColor3 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-3 option:selected').val();
    var VarColor4 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-4 option:selected').val();
    var VarColor5 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-5 option:selected').val();
    var VarColor6 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-6 option:selected').val();
    var VarColor7 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-7 option:selected').val();
    var totalVariant = [VarColor1, VarColor2, VarColor3, VarColor4, VarColor5, VarColor6, VarColor7];
   
  }

    var data = {
     "id": totalVariant,
     "quantity":1,
   }
  setTimeout(function () {
      $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: data,
      success: function() { 
        window.location.href = '/checkout';
      },
      error: function(error) {alert(error.responseJSON.message);}
     });
  }, 1000);

});

function clearCart() {
$.ajax({
    type: "POST",
    url: '/cart/clear.js',
    data: '',
    dataType: 'json',
    success: function() { 
     
    },
    error: function(XMLHttpRequest, textStatus) {
      /* error code */
    }
  });
}
  
